import { CustomerStateEnum } from '../api';
import { customerStateMapping } from '../constants';
import { useCompany } from '../hooks/company';

export const CustomerStateText = ({ state }: { state: CustomerStateEnum }) => {
  const { config: companyConfig } = useCompany();
  const stateText =
    companyConfig?.customerStateNameMap?.[state] || customerStateMapping[state] || state;
  return <span>{stateText}</span>;
};
